// Assets
export const LOGO_SVG_URL = "/assets/images/Logo.svg";

// Contact Information
export const CONTACT = {
  EMAIL: "requests@provider1st.com",
  PHONE: "855-514-2378",
  PHONE_DIAL: "800-818-2114",
};

// File Upload Configuration
export const FILE_UPLOAD = {
  MAX_FILE_SIZE_MB: 10,
  MAX_TOTAL_SIZE_MB: 20,
  ALLOWED_TYPES: [
    "application/pdf", // PDF
  "application/msword", // DOC
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
  "image/jpeg", // JPEG
  "image/png", // PNG
  "image/tiff", // TIFF
  "application/vnd.ms-excel", // XLS
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
  "text/plain" // TXT
  ],
  ALLOWED_EXTENSIONS: ["PDF", "DOC", "DOCX", "JPEG", "JPG", "PNG", "TIFF", "XLS", "XLSX", "TXT"],
};

// Date Format
export const DATE_FORMAT = "MM/DD/YYYY";

// Language Options
export const LANGUAGES = {
  ENGLISH: "en",
  SPANISH: "es",
};

// Brand Names (for translation exclusion)
export const BRAND_NAMES = ["Provider1st", "Trivalley"];
